const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  idOrUrlGetItem ({ state, commit, rootState }, params) {
    return rootState.axios.get('/tpsp/v1frontend/tptt-shake/id-or-url-get-item', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
